import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { checkAndSetUser } from "../../../redux/SearchSlice";

export function useMyTaskUserState() {
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.users.logInUser);
  const myTaskUser = useSelector((state) => state.search.myTaskUser);

  useEffect(() => {
    if (currentUser) {
      dispatch(checkAndSetUser(currentUser));
    }
  }, [currentUser, dispatch]);

  return {
    myTaskUser,
  };
}
